import { Injectable } from '@angular/core';
import { Subject,Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class SubscriptService {

  //大權限商店 發生選擇變化
  AuthChangeSubject = new Subject<any>();
  AuthChange$ = this.AuthChangeSubject.asObservable();


  //大權限商店 發生更新變化
  AuthUpdataSubject = new Subject<any>();
  AuthUpdata$ = this.AuthUpdataSubject.asObservable();



  constructor() {
    console.log('hs 建立')
  }

  





}
